import getTypesCount from "./getTypesCount";

import styles from "./file-list-short.module.scss";

import icons from "./icons";

const FileShortList = ({files}) => {
    const items = getTypesCount(files);

    const elements = items.map(({id, type, value, urls}) => <li key={id} className={styles.item}>
        <a href={urls[0]} target="_blank" rel="noopener noreferrer" className={styles.link}>
            {icons[type]} {value > 1 ? `+ ${value - 1}` : ""}
        </a>
    </li>);

    return (
        <ul>
            {elements}
        </ul>
    )
}

export default FileShortList;

FileShortList.defaultProps = {
    files: []
}
